<template>
  <div class="inline" v-if="type === 'inline'">
  <transition-group name="blur" tag="div">
    <div v-show="currentSrc === null" class="placeholder blur-transition" key="placeholder"></div>
    <canvas v-show="currentSrc === lowResSrc" height="17" width="27" key="canvas" class="blur-transition"></canvas>
    <img v-show="currentSrc === hiResSrc" :src="hiResSrc" key="image" class="blur-transition"></img>
  </transition-group>
  </div>
  <div v-else class="backgroundImage" :style="styleObject">
  </div>
</template>

<style scoped lang="scss">
  .inline img, .inline canvas, .inline .placeholder {
    height: 600px;
    width: 900px;
    position: absolute;
  }
  .placeholder {
    background-color: rgba(0,0,0,.05);
  }
  canvas {
  filter: blur(10px);
  }
  .blur-transition {
    transition: opacity linear .4s 0s;
    opacity: 1;
  }
  .blur-enter, .blur-leave {
    opacity: 0;
  }

  .backgroundImage {
    min-height: 100%;
    min-width: 100%;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
  }
</style>

<script>
  export default {
    name: 'BlurryImage',
    props: {
      hiResSrc: { default: undefined },
      lowResSrc: { default: undefined },
      type: { default: 'inline' },
    },
    data() {
      return {
        currentSrc: null,
      };
    },
    computed: {
      styleObject() {
        if (this.currentSrc === this.lowResSrc) {
          return {
            backgroundImage: `url('/static/img/overlays/05.png'), url(${this.currentSrc})`,
            backgroundRepeat: 'repeat, no-repeat',
            backgroundSize: 'auto, cover',
            backgroundPosition: 'top left, center center',
          };
        }
        return {
          backgroundImage: `url(${this.currentSrc})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
        };
      },
    },
    mounted() {
      const lowResImg = new Image();
      const hiResImg = new Image();
      const that = this;
      let isHiResLoaded = false;
      let context;
      if (this.type === 'inline') {
        context = this.$el.getElementsByTagName('canvas')[0].getContext('2d');
      }

      lowResImg.onload = () => {
        if (!isHiResLoaded) {
          if (this.type === 'inline') context.drawImage(lowResImg, 0, 0);
          that.currentSrc = that.lowResSrc;
        }
      };
      hiResImg.onload = () => {
        isHiResLoaded = true;
        that.currentSrc = that.hiResSrc;
      };
      lowResImg.src = that.lowResSrc;
      hiResImg.src = that.hiResSrc;
    },
  };
</script>



// WEBPACK FOOTER //
// BlurryImage.vue?1fd03c8f